(function(){
  'use strict';
  var root=document.getElementById('AarnaMiniCart');
  if(!root)return;

  /* This file used to own the drawer copy AND hardcode the microscope handle, so a
     cart holding only Aarna books was told to "Add Aarna to start your
     bundle savings". All copy and product detection now come from
     pk-offer-eligibility.js, the single source of truth, loaded on every page.
     This file owns the meter, the step labels, the upgrade button and the total. */
  var box=root.querySelector('[data-pkmc-bundle-progress]');
  var meter=root.querySelector('[data-pkmc-progress-meter]');
  var upgrade=root.querySelector('[data-pkmc-upgrade]');
  var checkoutLabel=root.querySelector('[data-pkmc-checkout-label]');
  var currentCart=null;
  var busy=false;
  var currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'CAD';

  /* The generic "shop" button must show the whole catalogue. It used to send every
     shopper to the Aarna product page regardless of context, which is why
     it never looked like a way to browse all products. */
  var SHOP_ALL_URL='/collections/all';
  var OFFICIAL_TWO_PACK={"White":"46379913019471","Yellow":"46379913183311","Pink":"46379913347151","Purple":"46379913510991"};
  var OFFICIAL_THREE_PACK={"White|White":"46379914297423","White|Yellow":"46379914461263","White|Pink":"46379914625103","White|Purple":"46379914788943","Yellow|White":"46379914821711","Yellow|Yellow":"46379914985551","Yellow|Pink":"46379915149391","Yellow|Purple":"46379915313231","Pink|White":"46379915345999","Pink|Yellow":"46379915509839","Pink|Pink":"46379915673679","Pink|Purple":"46379915837519","Purple|White":"46379915870287","Purple|Yellow":"46379916034127","Purple|Pink":"46379916197967","Purple|Purple":"46379916361807"};

  function selectedColors(entry){
    return String(entry&&entry.variant_title||'White').split('/').map(function(color){return color.trim();}).filter(Boolean);
  }

  function officialUpgrade(entry,step){
    var colors=selectedColors(entry);
    var first=colors[0]||'White';
    var second=colors[1]||first;
    if(step<=1)return {id:OFFICIAL_TWO_PACK[first]||OFFICIAL_TWO_PACK.White,qty:2};
    return {id:OFFICIAL_THREE_PACK[first+'|'+second]||OFFICIAL_THREE_PACK['White|White'],qty:3};
  }

  function money(cents){try{return new Intl.NumberFormat(document.documentElement.lang||'en-CA',{style:'currency',currency:currency}).format((Number(cents)||0)/100);}catch(error){return '$'+((Number(cents)||0)/100).toFixed(2);}}
  function api(){return window.AarnaOfferEligibility||null;}

  var STEP_LABELS={
    book:['1 BOOK','2 BOOKS','3 BOOKS'],
    scope:['BUY 1','BUY 2','BUY 3'],
    none:['BUY 1','BUY 2','BUY 3']
  };

  function render(cart){
    currentCart=cart;
    /* The base drawer replaces parts of its markup after quantity/removal actions.
       Re-query controls so totals and offer copy never update detached nodes. */
    box=root.querySelector('[data-pkmc-bundle-progress]');
    meter=root.querySelector('[data-pkmc-progress-meter]');
    upgrade=root.querySelector('[data-pkmc-upgrade]');
    checkoutLabel=root.querySelector('[data-pkmc-checkout-label]');
    if(checkoutLabel){
      var hasPayableCart=cart&&cart.items&&cart.items.length&&Number(cart.total_price)>0;
      checkoutLabel.textContent=hasPayableCart?'Checkout securely \u00b7 '+money(cart.total_price):'Checkout securely';
    }

    var offers=api();
    if(!offers||!offers.offerCopy){
      /* Eligibility script has not booted yet - retry rather than writing
         microscope copy over a coloring-book cart. */
      setTimeout(function(){if(currentCart)render(currentCart);},200);
      return;
    }

    var copy=offers.offerCopy(cart);
    if(!box)return;
    box.hidden=false;

    var labels=STEP_LABELS[copy.context]||STEP_LABELS.none;
    root.querySelectorAll('[data-pkmc-progress-step]').forEach(function(step){
      var index=Number(step.dataset.pkmcProgressStep);
      step.textContent=labels[index-1]||step.textContent;
      step.classList.toggle('is-active',index<=Math.max(0,Math.min(3,copy.step)));
    });

    if(meter)meter.style.transform='scaleX('+copy.meter+')';

    if(upgrade){
      if(copy.cta){
        upgrade.hidden=false;
        upgrade.textContent=copy.cta.label;
        upgrade.dataset.action=copy.cta.action;
      }else{
        upgrade.hidden=true;
      }
    }
  }

  function refresh(){
    return fetch('/cart.js',{headers:{Accept:'application/json'},credentials:'same-origin'})
      .then(function(response){return response.json();})
      .then(render)
      .catch(function(){});
  }

  /* Upgrade microscope offers to Shopify's official parent bundles. Buy 1 becomes
     a 2-pack; Buy 2 becomes a 3-pack. The new parent is added first, then the old
     line is removed, so a failed add can never empty the customer's cart. */
  function addOne(){
    if(busy||!currentCart)return;
    var offers=api();
    if(!offers)return;
    var copy=offers.offerCopy(currentCart);
    var entry=offers.upsellLine(currentCart);
    if(!entry){location.href=SHOP_ALL_URL;return;}

    if(copy.context!=='scope'){
      busy=true;
      if(upgrade)upgrade.disabled=true;
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({id:entry.key,quantity:Number(entry.quantity||0)+1})})
        .then(function(response){if(!response.ok)throw new Error('Unable to upgrade bundle');return response.json();})
        .then(function(cart){render(cart);document.dispatchEvent(new CustomEvent('peekora:cart:changed',{detail:{cart:cart}}));document.dispatchEvent(new CustomEvent('peekora:cart:updated',{detail:{open:false}}));})
        .catch(function(){})
        .finally(function(){busy=false;if(upgrade)upgrade.disabled=false;});
      return;
    }

    var target=officialUpgrade(entry,copy.step);
    busy=true;
    if(upgrade){upgrade.disabled=true;upgrade.textContent=target.qty===3?'Adding official 3-pack…':'Adding official 2-pack…';}
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json','X-Requested-With':'XMLHttpRequest'},
      credentials:'same-origin',
      body:JSON.stringify({items:[{id:target.id,quantity:1,properties:{_peekora_offer:'Official Shopify Fixed Bundle',_peekora_bundle_qty:String(target.qty),'Bundle includes':String(target.qty)+' × Aarna Explorer™','Bundle savings':target.qty===2?'$39.95 CAD':'$79.95 CAD'}}]})
    })
      .then(function(response){if(!response.ok)throw new Error('Unable to add official bundle');return response.json();})
      .then(function(){return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({id:entry.key,quantity:0})});})
      .then(function(response){if(!response.ok)throw new Error('Unable to finish bundle upgrade');return response.json();})
      .then(function(cart){
        render(cart);
        document.dispatchEvent(new CustomEvent('peekora:cart:changed',{detail:{cart:cart}}));
        document.dispatchEvent(new CustomEvent('peekora:cart:updated',{detail:{open:false}}));
      })
      .catch(function(){refresh();})
      .finally(function(){busy=false;if(upgrade)upgrade.disabled=false;});
  }

  if(upgrade)upgrade.addEventListener('click',function(){
    if(upgrade.dataset.action==='shop'){location.href=SHOP_ALL_URL;return;}
    addOne();
  });

  document.addEventListener('peekora:cart:updated',function(){setTimeout(refresh,140);});
  document.addEventListener('peekora:cart:changed',function(){setTimeout(refresh,100);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh);else refresh();
})();
